var map = {
	".": 118,
	"./": 118,
	"./Icons/Amazon": 390,
	"./Icons/Amazon.js": 390,
	"./Icons/Amex": 391,
	"./Icons/Amex.js": 391,
	"./Icons/Applepay": 392,
	"./Icons/Applepay.js": 392,
	"./Icons/Aura": 393,
	"./Icons/Aura.js": 393,
	"./Icons/Bb": 394,
	"./Icons/Bb.js": 394,
	"./Icons/Bitcoin": 395,
	"./Icons/Bitcoin.js": 395,
	"./Icons/Boleto": 396,
	"./Icons/Boleto.js": 396,
	"./Icons/Bradesco": 397,
	"./Icons/Bradesco.js": 397,
	"./Icons/Caixa": 398,
	"./Icons/Caixa.js": 398,
	"./Icons/Cielo": 399,
	"./Icons/Cielo.js": 399,
	"./Icons/Cirrus": 400,
	"./Icons/Cirrus.js": 400,
	"./Icons/Diners": 401,
	"./Icons/Diners.js": 401,
	"./Icons/DirectDebit": 402,
	"./Icons/DirectDebit.js": 402,
	"./Icons/Discover": 403,
	"./Icons/Discover.js": 403,
	"./Icons/Ebay": 404,
	"./Icons/Ebay.js": 404,
	"./Icons/Elavon": 405,
	"./Icons/Elavon.js": 405,
	"./Icons/Elo": 406,
	"./Icons/Elo.js": 406,
	"./Icons/Eway": 407,
	"./Icons/Eway.js": 407,
	"./Icons/Generic": 408,
	"./Icons/Generic.js": 408,
	"./Icons/Global": 409,
	"./Icons/Global.js": 409,
	"./Icons/Googlepay": 410,
	"./Icons/Googlepay.js": 410,
	"./Icons/Hsbc": 411,
	"./Icons/Hsbc.js": 411,
	"./Icons/Itau": 412,
	"./Icons/Itau.js": 412,
	"./Icons/Jcb": 413,
	"./Icons/Jcb.js": 413,
	"./Icons/Maestro": 414,
	"./Icons/Maestro.js": 414,
	"./Icons/Mastercard": 415,
	"./Icons/Mastercard.js": 415,
	"./Icons/Pagseguro": 416,
	"./Icons/Pagseguro.js": 416,
	"./Icons/Paypal": 417,
	"./Icons/Paypal.js": 417,
	"./Icons/Rede": 418,
	"./Icons/Rede.js": 418,
	"./Icons/Sage": 419,
	"./Icons/Sage.js": 419,
	"./Icons/Santander": 420,
	"./Icons/Santander.js": 420,
	"./Icons/Shopify": 421,
	"./Icons/Shopify.js": 421,
	"./Icons/Skrill": 422,
	"./Icons/Skrill.js": 422,
	"./Icons/SkrillMoneybookers": 423,
	"./Icons/SkrillMoneybookers.js": 423,
	"./Icons/Solo": 424,
	"./Icons/Solo.js": 424,
	"./Icons/Stone": 425,
	"./Icons/Stone.js": 425,
	"./Icons/Visa": 426,
	"./Icons/Visa.js": 426,
	"./Icons/VisaElectron": 427,
	"./Icons/VisaElectron.js": 427,
	"./Icons/Wallet": 428,
	"./Icons/Wallet.js": 428,
	"./Icons/Western": 429,
	"./Icons/Western.js": 429,
	"./Icons/Worldpay": 430,
	"./Icons/Worldpay.js": 430,
	"./Icons/transparent/AmazonTransparent": 431,
	"./Icons/transparent/AmazonTransparent.js": 431,
	"./Icons/transparent/BbTransparent": 432,
	"./Icons/transparent/BbTransparent.js": 432,
	"./Icons/transparent/BoletoTransparent": 433,
	"./Icons/transparent/BoletoTransparent.js": 433,
	"./Icons/transparent/BradescoTransparent": 434,
	"./Icons/transparent/BradescoTransparent.js": 434,
	"./Icons/transparent/CaixaTransparent": 435,
	"./Icons/transparent/CaixaTransparent.js": 435,
	"./Icons/transparent/CieloTransparent": 436,
	"./Icons/transparent/CieloTransparent.js": 436,
	"./Icons/transparent/ElavonTransparent": 437,
	"./Icons/transparent/ElavonTransparent.js": 437,
	"./Icons/transparent/GenericTransparent": 438,
	"./Icons/transparent/GenericTransparent.js": 438,
	"./Icons/transparent/GlobalTransparent": 439,
	"./Icons/transparent/GlobalTransparent.js": 439,
	"./Icons/transparent/HsbcTransparent": 440,
	"./Icons/transparent/HsbcTransparent.js": 440,
	"./Icons/transparent/ItauTransparent": 441,
	"./Icons/transparent/ItauTransparent.js": 441,
	"./Icons/transparent/PagseguroTransparent": 442,
	"./Icons/transparent/PagseguroTransparent.js": 442,
	"./Icons/transparent/PaypalTransparent": 443,
	"./Icons/transparent/PaypalTransparent.js": 443,
	"./Icons/transparent/RedeTransparent": 444,
	"./Icons/transparent/RedeTransparent.js": 444,
	"./Icons/transparent/SantanderTransparent": 445,
	"./Icons/transparent/SantanderTransparent.js": 445,
	"./Icons/transparent/StoneTransparent": 446,
	"./Icons/transparent/StoneTransparent.js": 446,
	"./Icons/transparent/WalletTransparent": 447,
	"./Icons/transparent/WalletTransparent.js": 447,
	"./Icons/transparent/WorldpayTransparent": 448,
	"./Icons/transparent/WorldpayTransparent.js": 448,
	"./index": 118,
	"./index.js": 118,
	"./remoteImages": 289,
	"./remoteImages.js": 289,
	"./test": 449,
	"./test.js": 449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 838;